import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'
import { TitleCount } from '../types/insights'

export function useTargetTitles(year?: string) {
  return useQuery({
    queryKey: ['insights', 'target-titles', year],
    queryFn: async () => {
      const params = year ? { year } : undefined
      const response = await get<{ data: TitleCount[] }>('/insights/target-titles', params)
      return response.data
    },
    staleTime: 1000 * 60 * 60, // 1 hour
    gcTime: 1000 * 60 * 60 * 2, // 2 hours
  })
} 